// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesList-cls1_gqO","cls2":"SavedReferencesList-cls2_sKn SavedReferencesList-cls1_gqO"};